import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap'
import StripeCheckout from 'react-stripe-checkout';
import firebase from "../../firebase/firebase-config";
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import { updateToken } from '../../authPages/BaseRequester';
import { v4 as uuidv4 } from 'uuid';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { toast, ToastContainer } from 'react-toastify';
import Loading from '../Loader/Loading';


// import { Axios } from 'axios';



function CreateGiftcards() {
    const params = useParams();

    const [user, setuser] = useState([])
    const [loading, setLoading] = useState(false)


    // const [search, setsearch] = useState('')
    const [query, setquery] = useState('')
    const [Ads_status_update, setAds_status_update] = useState({ status: 50 });
    const [customAmount, setCustomAmount] = useState(0);


    const [user_status_update, setuser_status_update_status_update] = useState({});

    const Adss_statuses = [

        {

            label: "50 Aed",

            value: 50,

        },

        {

            label: "100 Aed",

            value: 100,

        },
        {

            label: "200 Aed",

            value: 200,

        },



    ];


    const OnToken = (token) => {
        console.log(token);
    }
    const get_My_users = async () => {
        await firebase.firestore().collection('users').doc(params.id).onSnapshot((userss) => {
            setuser(userss.data());

        })



    }
    useEffect(() => {
        get_My_users();
    }, []);


    const elements = useElements();
    const stripe = useStripe();
    const submitStripeReq = async (e) => {
        e.preventDefault();

        setLoading(true);
        var token = await updateToken();
        const header = `Authorization: Bearer ${token}`;
        const config = {
            headers: { "Authorization": `Bearer ${token}` }
        }
        if (!stripe || !elements) {
            return;
        }
        toast.success('creating payment intent Successfully!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",

        })

        const res = await axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/pay', { email: 'waliidahsan@gmail.com', amount: Ads_status_update.status }, config);

        const clientSecret = res.data['client_secret'];
        const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
            }
        })
        if (stripeError) {
            alert(stripeError.message);
            return;
        }
        if (paymentIntent.status == "succeeded") {
            toast.success('payment Succeeded!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",

            })

            const uuid =
                uuidv4();
            const gift_card_code_uuid = uuidv4();
            await firebase.firestore().collection('GiftCards').doc(uuid).set({
                "createdOnDate": Date.now(),
                "giftCardCode": gift_card_code_uuid[0] + gift_card_code_uuid[1] + gift_card_code_uuid[2] + gift_card_code_uuid[3] + gift_card_code_uuid[4] + gift_card_code_uuid[5] + gift_card_code_uuid[6] + gift_card_code_uuid[7],

                "giftCardId": gift_card_code_uuid,

                "giftCardPrice": parseInt(Ads_status_update.status),

                "giftCardReceiptPdf": "https://firebasestorage.googleapis.com/v0/b/beyown-eead9.appspot.com/o/pdfs%2F1701251597011.pdf?alt=media&token=228e137a-df88-4806-b633-c52ec6e4680e",

                "giftCardType": parseInt(Ads_status_update.status) == 100 ? "Gold" : parseInt(Ads_status_update.status) == 50 ? "Silver" : "Brown",

                "id": uuid,

                "isUsed": false,

                "uid": params.id,

                "updatedOnDate": 0,

                "usedAtDate": 0,

                "usedById": "",
                "isCreatedByAdmin": true
            }).then((done) => {
                toast.success(`Gift card created Successfully! for @${user.userName} `, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",

                })
                setLoading(false);
                var NotificaitonData = {
                    id: uuid,
                    title: `Yahhooo! Gift Card Recieved ${Ads_status_update.status}AED`,
                    message: "Beyown Admin has sent you a giftcard with 3 months validty",
                    icon: "",
                    topics: "",
                    data: {},
                    type: "follow",
                    // senderId: "",
                    userId: params.id,
                }
                axios.post('https://us-central1-beyown-eead9.cloudfunctions.net/beyown/beyown/api/v1/user/sendNotification', NotificaitonData, config)


            }).catch((err) => {
                toast.error(`Error: ${err} `, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",

                })
                setLoading(false);

            })
        } else {

            alert('payment failed')
            setLoading(false);

        }
    }
    // if (loading) {
    //     return <Loading />
    // }

    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">
                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any User..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                    <Col xs="12">
                        <Row >
                            <Col className='lg-4'></Col>
                            <Col className='lg-4 mt-5'>
                                <div>

                                    {/* <h4>Select User</h4> */}

                                    {/* <select className="custom-select mt-3 text-info" value={user_status_update} onChange={(e) => { setuser_status_update_status_update(e.target.value) }} >

                                        {all_users.map((user) => {
                                            return <option className='text-info' value={user.value} >{user.label}--{user.data?.id}</option>
                                        })}
                                    </select> */}
                                    <Card className="card-user shadow-lg">


                                        <div className="Single_author">
                                            <div className="block block-one" />
                                            <div className="block block-two" />
                                            <div className="block block-three" />
                                            <div className="block block-four" />
                                            <div className="d-flex justify-content-between  " >
                                                <div className=" d-flex ">
                                                    <img
                                                        alt="..."
                                                        className="avatar_single_user"
                                                        src={user?.profilePicture}
                                                    />

                                                    <div className="ml-2 mt-2">
                                                        <div className='d-flex'>
                                                            <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{user?.userName}</p>
                                                            <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>{user?.fullName}</p>
                                                        </div>

                                                    </div>

                                                </div>
                                                <p className="description text-white m-2" style={{ fontSize: '14px' }}>Beyown user</p>


                                            </div>



                                        </div>




                                    </Card>
                                    <p>Pay {Ads_status_update.status} AED to @{user?.username} GiftCard</p>
                                    <div>
                                        <select className="custom-select mt-3 text-info" value={Ads_status_update.status} onChange={(e) => { setAds_status_update({ status: e.target.value }) }} >

                                            {Adss_statuses.map((status, i) => {
                                                return <option key={i} className='text-info' value={status.value} >{status.label}</option>
                                            })}
                                        </select>
                                        { }

                                        {/* {Ads_status_update.status == 0 ? <input className='form-control' value={customAmount} onChange={(e) => {
                                            console.log(e.target.value);
                                            setCustomAmount(e.target.value);
                                        }} /> : ''} */}
                                    </div>
                                </div>
                                <form onSubmit={submitStripeReq} >
                                    <label htmlFor='card-element'>Card</label>
                                    <CardElement id='card-element' />
                                    <Button>Stripe Pay</Button>
                                </form>

                                {/* <StripeCheckout
                                    token={OnToken}
                                    name="Beyown Admin Panel"
                                    stripeKey="pk_test_51KKcWOKNgqBeLJ9mCvKstO4a2wGZQ6TwbAmHA1V85COWfsOEBJUvklrjLJO9ohUwvy9AQwd3f129TH00WnfzqBsT00BA9fA6uJ"
                                    description="Beyown Fashion And Designing Co." // the pop-in header subtitle
                                    image="https://www.vidhub.co/assets/logos/vidhub-icon-2e5c629f64ced5598a56387d4e3d0c7c.png" // the pop-in header image (default none)
                                    ComponentClass='div'
                                    // change amount 
                                    amount={Ads_status_update.status * 100} // cents
                                    currency="AED"
                                    email="support@beyown.com"
                                    billingAddress={false}
                                    zipCode={false}
                                    alipay={true}
                                    bitcoin={true}
                                    allowRememberMe={true}
                                    reconfigureOnUpdate={false}
                                >
                                    <button className="btn btn-lg btn-primary text-white">Stripe Pay</button>
                                </StripeCheckout> */}
                            </Col>
                            <Col className='lg-4'></Col>

                        </Row>

                    </Col>
                </Row>



            </div>

        </>
    )
}

export default CreateGiftcards